import { AxiosResponse, AxiosRequestConfig } from 'axios';
import client from 'api/client';
import { PaymentStatus } from 'api/models/payload/ClientsPayload';

export function get(
    application_id: string,
    payment_status: PaymentStatus,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse> {
    return client.get(
        `/set_client_payment_status/${application_id}/${payment_status}`,
        customConfig
    );
}
